import React from 'react';
import classnames from 'classnames';

import './style.scss';

const Tag = ({ text, icon, className }) => {
  return (
    <div className={classnames('Tag', className, { default: !icon })}>
      {icon && <div className={`icon icon-${icon}`} />}
      <span>{text}</span>
    </div>
  );
};

export default Tag;
